export default __webpack_public_path__ + "static/media/emotion_icon.fbcc818b.svg";